import React from "react"
import Stack from '@mui/material/Stack'
import ListItem from '@mui/material/ListItem'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import Typography from '@mui/material/Typography'

export default function CustomListItem(props) {
    const {text} = props

    return (
        <>
            <ListItem
                sx={{padding: 1}}
            >
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ flexGrow: 1 }}
                >
                    <Typography variant="h5">
                        {text}
                    </Typography>

                    <CheckCircleIcon sx={{ mx: 1}} fontSize="large" color="whatsApp"/>
                </Stack>
            </ListItem>
        </>
    )
}